import React, { useState, useEffect } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { getRequest, putRequest } from "../../helpers/api.helper";
import { StepPropsType } from "../../types";
import {
  Age_Preferences,
  heightOptions,
  totalPropertyValueOptions,
} from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import ProfileCompletionSuccess from "./ProfileCompletionSuccess";
import { useLanguage } from "../../context/LanguageContext";

const splitOrEmpty = (value?: string | string[]) => {
  if (!value) return [];

  // Array case
  if (Array.isArray(value)) {
    const cleaned = value
      .map((v) => String(v).trim())
      .filter(Boolean)
      .filter(
        (v) =>
          v.toLowerCase() !== "any" &&
          v.toLowerCase() !== "any," &&
          v.toLowerCase() !== "any ",
      );

    return cleaned;
  }

  // String case
  if (typeof value === "string") {
    const raw = value.trim();
    if (!raw) return [];
    if (raw.toLowerCase() === "any") return []; // ✅ IMPORTANT

    return raw
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean)
      .filter((v) => v.toLowerCase() !== "any"); // ✅ IMPORTANT
  }

  return [];
};

const Step9 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  profileDescriptionEnabled,
  setCompletedSteps,
  onResetFlow,
}: StepPropsType) => {
  const { t } = useLanguage();

  const [modalConfig, setModalConfig] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [city, setCity] = useState([]);
  const [education, setEducation] = useState([]);
  const [annualIncome, setAnnualIncome] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [star, setStar] = useState([]);
  const [rashi, setRashi] = useState([]);
  const [dosham, setDosham] = useState([]);
  const [extraSkills, setExtraSkills] = useState([]);
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubcaste] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [selectedOptions2, setSelectedOptions2] = useState<any>({});
  const [selectedOptions3, setSelectedOptions3] = useState<any>({});
  const [selectedOptions4, setSelectedOptions4] = useState<any>({});
  const [selectedOptions5, setSelectedOptions5] = useState<any>({});
  const [selectedOptions6, setSelectedOptions6] = useState<any>({});
  const [isSuccess, setIsSuccess] = useState(false);
  const [userData, setUserData] = useState<any>(null);

  const dropdownOptions: any = {
    Religion_Preferences: [
      { value: "hindu", label: "Hindu" },
      { value: "muslim", label: "Muslim" },
      { value: "christian", label: "Christian" },
      { value: "sikh", label: "Sikh" },
      { value: "buddhist", label: "Buddhist" },
      { value: "jain", label: "Jain" },
      { value: "parsi", label: "Parsi" },
      { value: "other", label: "Other" },
    ],
    Caste_Preferences: [
      ...caste.map((caste: any) => ({
        value: caste.caste,
        label: caste.caste,
      })),
    ],
    Sub_Caste_Preferences: [
      ...subcaste.map((caste: any) => ({
        value: caste.sub_caste,
        label: caste.sub_caste,
      })),
    ],
    Mother_Toungue_Preferences: [
      { value: "bengali", label: "Bengali" },
      { value: "english", label: "English" },
      { value: "hindi", label: "Hindi" },
      { value: "kannada", label: "Kannada" },
      { value: "marathi", label: "Marathi" },
      { value: "tamil", label: "Tamil" },
      { value: "telugu", label: "Telugu" },
    ],
    Marital_Status_Preferences: [
      { value: "neverMarried", label: "Never Married" },
      { value: "awaitingDivorce", label: "Awaiting Divorce" },
      { value: "divorced", label: "Divorced" },
      { value: "widow", label: "Widowed" },
    ],
    children_PreferenceOptions: [
      { value: "no_children", label: "Not accepted any childrens" },
      { value: "only_1_kid", label: "Accepted only 1kids" },
      { value: "only_2_kids", label: "Accepted only 2 kids" },
      { value: "doesnt_matter", label: "Doesn't matter" },
    ],
    Age_Preferences: Age_Preferences,
    Height_Preferences: heightOptions,
    Created_by_preference: [
      { value: "self", label: "Self" },
      { value: "father", label: "Father" },
      { value: "mother", label: "Mother" },
      { value: "friend", label: "Friend" },
      { value: "relatives", label: "Relatives" },
      { value: "sister", label: "Sister" },
      { value: "brother", label: "Brother" },
      { value: "other_mediator", label: "Other Mediator" },
    ],
  };

  const dropdownOptions2: any = {
    Education_Preferences: [
      ...education.map((education: any) => ({
        value: education.education,
        label: education.education,
      })),
    ],
    Occupation_Preference: [
      ...occupation.map((occupation: any) => ({
        value: occupation.occupation,
        label: occupation.occupation,
      })),
    ],
    Job_Location_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
    Anuual_Income_Preference: [
      ...annualIncome.map((annual_income: any) => ({
        value: annual_income.annual_income,
        label: annual_income.annual_income,
      })),
    ],
    Partner_Family_Preference: [
      { value: "Joint_Family", label: "Joint Family" },
      { value: "Nuclear_Family", label: "Nuclear Family" },
      { value: "Family-Oriented_Partner", label: "Family-Oriented Partner" },
      { value: "Independent_Partner", label: "Independent Partner" },
      { value: "Living_with_Parents", label: "Living with Parents" },
    ],

    Setelled_Location_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
  };

  const dropdownOptions3: any = {
    House_Type_Preference: [
      { value: "GroundFloor", label: "Ground Floor" },
      { value: "g+1", label: "G+1" },
      { value: "g+2", label: "G+2" },
      { value: "g+3", label: "G+3" },
      { value: "g+4", label: "G+4" },
      { value: "g+5", label: "G+5" },
      { value: "g+6", label: "G+6" },
      { value: "g+7", label: "G+7" },
      { value: "g+8", label: "G+8" },
      { value: "g+9", label: "G+9" },
      { value: "g+10", label: "G+10" },
    ],
    Own_House_sq_Yard_Preference: [
      ...Array.from({ length: 1000 - 70 + 1 }, (_, index) => 70 + index).map(
        (sqFeet) => ({
          value: String(sqFeet), // ✅
          label: `${sqFeet} Yards`,
        }),
      ),
    ],
    Monthly_Rent_Preference: [
      { value: "", label: "Select total value", isDisabled: true },
      ...Array.from({ length: 200 }, (_, index) => 50000 + index * 50000).map(
        (value) => ({
          value: String(value), // ✅
          label: `₹${value.toLocaleString("en-IN")}`,
        }),
      ),
    ],
    Open_Plots_Preference: [
      ...Array.from({ length: 20 }, (_, i) => i + 1).map((value) => ({
        value: String(value), // ✅
        label: value.toString(),
      })),
    ],
    Apartment_Flats_Preference: [
      ...Array.from({ length: 20 }, (_, i) => i + 1).map((value) => ({
        value: String(value), // ✅
        label: value.toString(),
      })),
    ],
    Own_Location_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],

    Agriculture_Land_Preference: [
      ...Array.from({ length: 1000 - 70 + 1 }, (_, index) => 70 + index).map(
        (sqFeet) => ({
          value: String(sqFeet), // ✅
          label: `${sqFeet} Acres`,
        }),
      ),
    ],
    Total_Property_Value_Preference: {
      section: "about",
      type: "multi",
      options: totalPropertyValueOptions,
    },
  };
  const dropdownOptions4: any = {
    Country_Preference: [
      ...country.map((job_location: any) => ({
        value: job_location.country,
        label: job_location.country,
      })),
    ],
    State_Preference: [
      ...state.map((job_location: any) => ({
        value: job_location.state,
        label: job_location.state,
      })),
    ],
    City_Preference: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
    Citizenship_Preference: [
      { value: "", label: "Select Citizenship", isDisabled: true }, // Disabled option as a placeholder
      { value: "Indian", label: "Indian" },
      { value: "NRI", label: "NRI" },
    ],
  };

  const dropdownOptions5: any = {
    Star_Preference: [
      ...star.map((s: any) => ({
        value: s.star,
        label: s.star,
      })),
    ],
    Rashi_Preference: [
      ...rashi.map((rashi: any) => ({
        value: rashi.rashi,
        label: rashi.rashi,
      })),
    ],
    Dosham_Preference: [
      ...dosham.map((dosham: any) => ({
        value: dosham.dosham,
        label: dosham.dosham,
      })),
    ],
  };

  const dropdownOptions6: any = {
    Eating_Preference: [
      { value: "nonVeg", label: "Non Vegetarian" },
      { value: "veg", label: "Vegetarian" },
      { value: "egg", label: "Eggeterian" },
    ],
    Drinking_Preference: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
      { value: "Occasional", label: "Occasional" },
    ],
    Smoking_Preference: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
      { value: "Occasional", label: "Occasional" },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/profile/step9");
        if (response.success) {
          setCity(response.data.city);
          setEducation(response.data.education);
          setAnnualIncome(response.data.annual_income);
          setExtraSkills(response.data.extra_skills);
          setOccupation(response.data.occupation);
          setCountry(response.data.country);
          setState(response.data.state);
          setCaste(response.data.caste);
          setSubcaste(response.data.sub_caste);
          setStar(response.data.star);
          setRashi(response.data.raasi);
        }
      } catch (error) {
        console.error(`Error fetching data:`, error);
      }
    };
    fetchData();
  }, []);

  const openModal = (key: any, section: any, showSelectAll = true) => {
    const options = getOptionsForSection(key, section);

    setModalConfig({ key, section, options, showSelectAll });
    setSearchTerm("");

    // ✅ if field is undefined, set it to Any ([])
    const [currentState, setState] = getStateForSection(section);
    if (currentState[key] === undefined) {
      setState({ ...currentState, [key]: [] }); // default Any
    }
  };

  const closeModal = () => {
    setModalConfig(null);
    setSearchTerm("");
  };

  type StateSetter = React.Dispatch<React.SetStateAction<Record<string, any>>>;

  const getStateForSection = (
    section: number,
  ): [Record<string, any>, StateSetter] => {
    switch (section) {
      case 1:
        return [selectedOptions, setSelectedOptions];
      case 2:
        return [selectedOptions2, setSelectedOptions2];
      case 3:
        return [selectedOptions3, setSelectedOptions3];
      case 4:
        return [selectedOptions4, setSelectedOptions4];
      case 5:
        return [selectedOptions5, setSelectedOptions5];
      case 6:
        return [selectedOptions6, setSelectedOptions6];
      default:
        return [selectedOptions, setSelectedOptions];
    }
  };

  const getOptionsForSection = (key: string, section: number) => {
    switch (section) {
      case 1:
        return dropdownOptions[key] || [];
      case 2:
        return dropdownOptions2[key] || [];
      case 3:
        return dropdownOptions3[key] || [];
      case 4:
        return dropdownOptions4[key] || [];
      case 5:
        return dropdownOptions5[key] || [];
      case 6:
        return dropdownOptions6[key] || [];
      default:
        return [];
    }
  };

  const handleCheckboxChange = (event: any, option: any) => {
    if (!modalConfig) return;

    const { checked } = event.target;
    const { key, section } = modalConfig;
    const [currentState, setState] = getStateForSection(section);

    const rawSelected = currentState[key];

    const allSelectable = (
      Array.isArray(modalConfig.options) ? modalConfig.options : []
    )
      .filter((o: any) => !o.isDisabled)
      .map((o: any) => o.value);

    // ✅ Determine base selection for UI actions
    // Any => treat as all selected
    // None (null) => treat as none selected
    // Array => use as is
    const base =
      rawSelected === null
        ? []
        : Array.isArray(rawSelected) && rawSelected.length === 0
          ? allSelectable
          : Array.isArray(rawSelected)
            ? rawSelected
            : [];

    const updated = checked
      ? [...new Set([...base, option.value])]
      : base.filter((v: any) => v !== option.value);

    // ✅ If user selected ALL => store Any ([])
    const isAll =
      allSelectable.length > 0 &&
      allSelectable.every((v: any) => updated.includes(v));

    // ✅ If user selected NONE => store null
    const isNone = updated.length === 0;

    setState({
      ...currentState,
      [key]: isAll ? [] : isNone ? null : updated,
    });
  };

  // Unified select all handler
  const handleSelectAllChange = (event: any) => {
    if (!modalConfig) return;

    const { checked } = event.target;
    const { key, section } = modalConfig;
    const [currentState, setState] = getStateForSection(section);

    setState({
      ...currentState,
      [key]: checked ? [] : null, // ✅ checked => Any, unchecked => none selected
    });
  };

  // Get display text based on section
  const getDisplayText = (key: string, section: number) => {
    const [currentState] = getStateForSection(section);
    const options: any[] = getOptionsForSection(key, section);

    const value = currentState[key];

    // ✅ undefined OR [] => Any
    if (value === undefined) return "Any";
    if (Array.isArray(value) && value.length === 0) return "Any";

    // ✅ null means none selected (because you used null for "uncheck Any")
    if (value === null) return "None";

    // ✅ normal selected list
    const selectedArr = Array.isArray(value) ? value : [];
    return options
      .filter((opt: any) => selectedArr.includes(opt.value))
      .map((opt: any) => opt.label)
      .join(", ");
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  const hasNeverMarried =
    Array.isArray(selectedOptions.Marital_Status_Preferences) &&
    selectedOptions.Marital_Status_Preferences.includes("neverMarried");

  useEffect(() => {
    if (!hasNeverMarried) return;
    setSelectedOptions((prev: any) => ({
      ...prev,
      children_PreferenceOptions: undefined,
    }));
    if (modalConfig?.key === "children_PreferenceOptions") {
      closeModal();
    }
  }, [hasNeverMarried, modalConfig]);

  useEffect(() => {
    if (!profileId) return;

    const fetchStep9Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.success || !res.data) return;

        const data = res.data;

        /* ---------------- SECTION 1 ---------------- */
        setSelectedOptions({
          Created_by_preference: Array.isArray(data.partnerCreatedBy)
            ? (data.partnerCreatedBy[0] ?? "")
            : (data.partnerCreatedBy ?? ""),

          Religion_Preferences: splitOrEmpty(data.religionPreferences),
          Caste_Preferences: splitOrEmpty(data.castePreferences),
          Sub_Caste_Preferences: splitOrEmpty(data.subCastePreferences),

          Marital_Status_Preferences: splitOrEmpty(
            data.maritalStatusPreferences,
          ),
          children_PreferenceOptions: splitOrEmpty(data.childrenPreferences),
          Mother_Toungue_Preferences: splitOrEmpty(
            data.motherTonguePreferences,
          ),
          Age_Preferences: splitOrEmpty(data.agePreferences),
          Height_Preferences: splitOrEmpty(data.heightPreferences),
        });

        /* ---------------- SECTION 2 ---------------- */
        setSelectedOptions2({
          Education_Preferences: splitOrEmpty(data.partnerEducationPreferences),
          Occupation_Preference: splitOrEmpty(
            data.partnerOccupationPreferences,
          ),
          Job_Location_Preference: splitOrEmpty(
            data.partnerJobLocationPreferences,
          ),
          Anuual_Income_Preference: splitOrEmpty(data.partnerAnnualIncome), // ✅
          Partner_Family_Preference: splitOrEmpty(data.familyPreferences), // ✅
          Setelled_Location_Preference: splitOrEmpty(
            data.settledLocationPreferences,
          ),
        });

        /* ---------------- SECTION 3 ---------------- */
        setSelectedOptions3({
          House_Type_Preference: splitOrEmpty(data.ownHousePreferences),
          Own_House_sq_Yard_Preference: splitOrEmpty(
            data.squareYardPreferences,
          ),
          Monthly_Rent_Preference: splitOrEmpty(data.monthlyRentPreferences),

          Open_Plots_Preference: splitOrEmpty(data.plotPreference), // ✅
          Apartment_Flats_Preference: splitOrEmpty(data.flatPreference),

          Own_Location_Preference: splitOrEmpty(data.ownLocationPreferences),

          Agriculture_Land_Preference: splitOrEmpty(
            data.agricultureLandPreference,
          ), // ✅
          Total_Property_Value_Preference: splitOrEmpty(
            data.totalPropertyValuePreference,
          ), // ✅
        });

        /* ---------------- SECTION 4 ---------------- */
        setSelectedOptions4({
          Country_Preference: splitOrEmpty(data.countryLocationPreferences),
          State_Preference: splitOrEmpty(data.stateLocationPreferences),
          City_Preference: splitOrEmpty(data.cityLocationPreferences),
          Citizenship_Preference: splitOrEmpty(data.citizenshipPreferences),
        });

        /* ---------------- SECTION 5 ---------------- */
        setSelectedOptions5({
          Star_Preference: splitOrEmpty(data.starPreferences),
          Rashi_Preference: splitOrEmpty(data.rashiPreferences),
          Dosham_Preference: splitOrEmpty(data.doshamPreferences),
        });

        /* ---------------- SECTION 6 ---------------- */
        setSelectedOptions6({
          Eating_Preference: splitOrEmpty(data.eatingHabitsPreferences),
          Drinking_Preference: splitOrEmpty(data.drinkingHabitsPreferences),
          Smoking_Preference: splitOrEmpty(data.smokingHabitsPreferences),
        });
      } catch (err) {
        console.error("Failed to prefill Step9", err);
      }
    };

    if (bureauId) fetchStep9Data();
  }, [profileId, bureauId]);

  const arrOrAny = (arr: any) => {
    if (arr === null) return ["any"]; // ✅ none selected => treat as any in DB

    const selected = (Array.isArray(arr) ? arr : [])
      .map((v) => String(v).trim())
      .filter(Boolean);

    return selected.length === 0 ? ["any"] : selected; // [] => Any
  };

  // single select fields that you currently store as string -> convert to array
  const oneOrAny = (val: any) => {
    const v = String(val ?? "").trim();
    if (!v || v.toLowerCase() === "any") return ["any"];
    return [v];
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const isLastVisibleStep = currentStep >= steps.length;

    // Build the form data to send with default values as "Any"
    const formDataToSend = {
      partnerCreatedBy: oneOrAny(selectedOptions.Created_by_preference),

      religionPreferences: arrOrAny(selectedOptions.Religion_Preferences),
      castePreferences: arrOrAny(selectedOptions.Caste_Preferences),
      subCastePreferences: arrOrAny(selectedOptions.Sub_Caste_Preferences),
      maritalStatusPreferences: arrOrAny(
        selectedOptions.Marital_Status_Preferences,
      ),
      childrenPreferences: arrOrAny(selectedOptions.children_PreferenceOptions),
      motherTonguePreferences: arrOrAny(
        selectedOptions.Mother_Toungue_Preferences,
      ),
      agePreferences: arrOrAny(selectedOptions.Age_Preferences),
      heightPreferences: arrOrAny(selectedOptions.Height_Preferences),

      partnerEducationPreferences: arrOrAny(
        selectedOptions2.Education_Preferences,
      ),
      partnerOccupationPreferences: arrOrAny(
        selectedOptions2.Occupation_Preference,
      ),
      partnerJobLocationPreferences: arrOrAny(
        selectedOptions2.Job_Location_Preference,
      ),
      partnerAnnualIncome: arrOrAny(selectedOptions2.Anuual_Income_Preference),
      familyPreferences: arrOrAny(selectedOptions2.Partner_Family_Preference),
      settledLocationPreferences: arrOrAny(
        selectedOptions2.Setelled_Location_Preference,
      ),

      ownHousePreferences: arrOrAny(selectedOptions3.House_Type_Preference),
      squareYardPreferences: arrOrAny(
        selectedOptions3.Own_House_sq_Yard_Preference,
      ),
      monthlyRentPreferences: arrOrAny(
        selectedOptions3.Monthly_Rent_Preference,
      ),
      plotPreference: arrOrAny(selectedOptions3.Open_Plots_Preference),
      flatPreference: arrOrAny(selectedOptions3.Apartment_Flats_Preference),
      ownLocationPreferences: arrOrAny(
        selectedOptions3.Own_Location_Preference,
      ),
      agricultureLandPreference: arrOrAny(
        selectedOptions3.Agriculture_Land_Preference,
      ),
      totalPropertyValuePreference: arrOrAny(
        selectedOptions3.Total_Property_Value_Preference,
      ),

      countryLocationPreferences: arrOrAny(selectedOptions4.Country_Preference),
      stateLocationPreferences: arrOrAny(selectedOptions4.State_Preference),
      cityLocationPreferences: arrOrAny(selectedOptions4.City_Preference),
      citizenshipPreferences: arrOrAny(selectedOptions4.Citizenship_Preference),

      starPreferences: arrOrAny(selectedOptions5.Star_Preference),
      rashiPreferences: arrOrAny(selectedOptions5.Rashi_Preference),
      doshamPreferences: arrOrAny(selectedOptions5.Dosham_Preference),

      eatingHabitsPreferences: arrOrAny(selectedOptions6.Eating_Preference),
      drinkingHabitsPreferences: arrOrAny(selectedOptions6.Drinking_Preference),
      smokingHabitsPreferences: arrOrAny(selectedOptions6.Smoking_Preference),

      step9: 1,
    };

    try {
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        formDataToSend,
      );

      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (isLastVisibleStep) {
          const nextUserData =
            response.data?.user ??
            (await (async () => {
              if (!profileId) return null;
              try {
                const profileResponse = await getRequest(
                  `/user/profile/${profileId.martialId || profileId.userId}`,
                );
                return profileResponse.success ? profileResponse.data : null;
              } catch (fetchError) {
                console.error(
                  "Failed to fetch profile after submission",
                  fetchError,
                );
                return null;
              }
            })());
          setUserData(nextUserData);
          setIsSuccess(true);
        } else {
          if (currentStep < steps.length) {
            setCurrentStep(currentStep + 1);
          }
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error) {
      console.error("Error updating details:", error);
    }
  };

  const modalOptions = Array.isArray(modalConfig?.options)
    ? modalConfig.options
    : modalConfig?.options?.options || [];

  const filteredOptions = modalConfig
    ? modalOptions.filter((option: any) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : [];

  const isAllSelected = modalConfig
    ? (() => {
        const [currentState] = getStateForSection(modalConfig.section);
        const selected = currentState[modalConfig.key];

        // ✅ undefined means default Any
        if (selected === undefined) return true;

        return Array.isArray(selected) && selected.length === 0; // [] means Any
      })()
    : false;

  const navigate = useNavigate();

  // Navigate to dashboard
  const handleGoToDashboard = () => {
    if (bureauId) {
      navigate(`/profile/${bureauId}`);
      return;
    }

    navigate("/admin/dashboard");
  };

  // Success message component
  if (isSuccess) {
    return (
      <ProfileCompletionSuccess
        userData={userData}
        onGoToDashboard={handleGoToDashboard}
        showGoToDashboard={!!bureauId}
        showShareActions={!!bureauId}
        onClose={() => {
          setIsSuccess(false);
          onResetFlow?.();
        }}
      />
    );
  }

  return (
    <div className="w-full max-w-lg bg-white">
      <div className="space-y-6 px-3">
        {/* Block 1: Caste & Religion */}
        <section className="shadow-2xl bg-white px-2 py-4 rounded">
          <div className="text-center pb-3">
            <button className="w-full bg-red-400 text-white p-3 rounded-lg hover:bg-red-500 transition-colors font-semibold ">
              * {t("Caste & Religion Preferences")} *
            </button>
          </div>
          {Object.keys(dropdownOptions)
            .filter(
              (key) => key !== "children_PreferenceOptions" || !hasNeverMarried,
            )
            .map((key) => (
              <div key={key} className="mb-[20px] rounded-lg">
                <label className="block text-red-500 font-medium mb-2 capitalize">
                  {t(key.replace(/_/g, " "))}
                </label>
                <div
                  className="flex flex-col w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all"
                  onClick={() => openModal(key, 1)}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500 text-md font-medium">
                      {getDisplayText(key, 1)}
                    </span>
                    <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                  </div>
                </div>
              </div>
            ))}
        </section>

        {/* Block 4: Horoscope */}
        <section className="shadow-2xl bg-white px-2 py-4 rounded">
          <div className="text-center pb-3">
            <button className="w-full bg-red-400 text-white p-3 rounded-lg hover:bg-red-500 transition-colors font-semibold">
              * {t("Horoscope Preferences")} *
            </button>
          </div>
          {Object.keys(dropdownOptions5).map((key) => (
            <div key={key} className="mb-[20px] rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {t(key.replace(/_/g, " "))}
              </label>
              <div
                className="flex flex-col w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal(key, 5)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {getDisplayText(key, 5)}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* Block 5: Hobbies */}
        <section className="shadow-2xl bg-white px-2 py-4 rounded">
          <div className="text-center pb-3">
            <button className="w-full bg-red-400 text-white p-3 rounded-lg hover:bg-red-500 transition-colors font-semibold">
              * {t("Hobbies Preferences")} *
            </button>
          </div>
          {Object.keys(dropdownOptions6).map((key) => (
            <div key={key} className="mb-[20px] rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {t(key.replace(/_/g, " "))}
              </label>
              <div
                className="flex flex-col w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal(key, 6, false)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {getDisplayText(key, 6)}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* Block 2: Education & Job */}
        <section className="shadow-2xl bg-white px-2 py-4 rounded">
          <div className="text-center pb-3">
            <button className="w-full bg-red-400 text-white p-3 rounded-lg hover:bg-red-500 transition-colors font-semibold">
              * {t("Education & Job Preferences")} *
            </button>
          </div>
          {Object.keys(dropdownOptions2).map((key) => (
            <div key={key} className="mb-[20px] rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {t(key.replace(/_/g, " "))}
              </label>
              <div
                className="flex flex-col w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal(key, 2)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {getDisplayText(key, 2)}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* Block 3: Property */}
        <section className="shadow-2xl bg-white px-2 py-4 rounded">
          <div className="text-center pb-3">
            <button className="w-full bg-red-400 text-white p-3 rounded-lg hover:bg-red-500 transition-colors font-semibold">
              * {t("Property Preferences")} *
            </button>
          </div>
          {Object.keys(dropdownOptions3).map((key) => (
            <div key={key} className="mb-[20px] rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {t(key.replace(/_/g, " "))}
              </label>
              <div
                className="flex flex-col w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal(key, 3)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {getDisplayText(key, 3)}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* Block 6: Location */}
        <section className="shadow-2xl bg-white px-2 py-4 rounded">
          <div className="text-center pb-3">
            <button className="w-full bg-red-400 text-white p-3 rounded-lg hover:bg-red-500 transition-colors font-semibold">
              * {t("Location Preferences")} *
            </button>
          </div>
          {Object.keys(dropdownOptions4).map((key) => (
            <div key={key} className="mb-[20px] rounded-lg">
              <label className="block text-red-500 font-medium mb-2 capitalize">
                {t(key.replace(/_/g, " "))}
              </label>
              <div
                className="flex flex-col w-full rounded-lg border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal(key, 4)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {getDisplayText(key, 4)}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </div>
          ))}
        </section>

        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
          {/* <button
            onClick={() => setCurrentStep(Math.max(1, currentStep - 1))}
            className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Previous
          </button> */}
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
          >
            {currentStep === steps?.length ? t("Submit") : t("Next Step")}
          </button>
        </div>
      </div>

      {/* Unified Modal */}
      {modalConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalConfig.key.replace(/_/g, " "))}
            </h2>

            {modalConfig.showSelectAll && (
              <div className="flex items-center space-x-2 mb-4">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAllChange}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Any</label>
              </div>
            )}

            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalConfig.key.replace(/_/g, " ")}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {(() => {
              const [modalState] = getStateForSection(modalConfig.section);

              const rawSelected = modalState[modalConfig.key];

              const allSelectable = (
                Array.isArray(modalConfig.options) ? modalConfig.options : []
              )
                .filter((o: any) => !o.isDisabled)
                .map((o: any) => o.value);

              // ✅ UI selected
              const uiSelected =
                rawSelected === null
                  ? [] // none selected
                  : rawSelected === undefined
                    ? allSelectable // ✅ default Any => all checked
                    : Array.isArray(rawSelected) && rawSelected.length === 0
                      ? allSelectable // Any => all checked
                      : Array.isArray(rawSelected)
                        ? rawSelected
                        : [];

              return (
                <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
                  {filteredOptions.map((option: any, index: any) => (
                    <React.Fragment key={index}>
                      <div className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={uiSelected.includes(option.value)}
                          disabled={option.isDisabled}
                          onChange={(e) => handleCheckboxChange(e, option)}
                          className="form-checkbox h-4 w-4 text-red-600"
                        />
                        <label className="block text-gray-700">
                          {option.label}
                        </label>
                      </div>
                      <hr className="border-gray-200 mt-3 mb-3" />
                    </React.Fragment>
                  ))}
                </div>
              );
            })()}

            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step9;
